import { InternalMessageBus, InternalMessageBusListener } from "sb-resp-lib";

export interface IMessageBus {
    getSubscription<T>(channel: string, handler: InternalMessageBusListener<T>, context:any): () => void;
    emit(channel: string, ...params:any[]): void;
}

export class MessageBus implements IMessageBus {

    private readonly messageBus: InternalMessageBus;

    constructor(messageBus: InternalMessageBus) {
        this.messageBus = messageBus;
    }

    getSubscription<T>(channel: string, handler: InternalMessageBusListener<T>, context:any) {
        this.messageBus.on(channel, handler, context);
        return () => this.messageBus.off(channel, handler, context);
    }

    emit(channel:string, ...params:any[]): void {
        this.messageBus.emit(channel, ...params);
    }
}